import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { InstallationAction, ProductAction } from '../../actions';
import InstallationStep2 from '../../components/installation/InstallationStep2';
import InstallationStep3 from '../../components/installation/InstallationStep3';
import InstallationStep4 from '../../components/installation/InstallationStep4';
import InstallationStep5 from '../../components/installation/InstallationStep5';
import InstallationStep6 from '../../components/installation/InstallationStep6';
import { SpecialityTypes } from '../../config/RayCodes';
import { CountryCode } from '../../config';
import { useParams, Link } from 'react-router-dom';
import { RayForm, RaySignaturePad } from '../../components/common';
import { ExportPdfReport } from '../../components/common/ExportPdfReport';
import { Translate as t } from '../../config/Translate';
import { Loading } from '../../components/common/Loading';

const AdminInstallationInfo = ({ installation, product, GetInstallation, GetProduct }) => {

    const { id, view } = useParams();
    // 조회 완료(성공·실패) 여부: 설치 보고서 → 제품 순서. 현재 id 와 응답 _id 가 일치할 때만 내용을 그린다.
    const [installDone, setInstallDone] = useState(false);
    const [productDone, setProductDone] = useState(false);
    const isSummary = true;

    const isMatched = id == installation?._id;
    const isLoading = isMatched ? (!!installation.sn && !productDone) : !installDone;
    // 제품 조회가 실패해도 redux 에 직전 제품이 남으므로, 이 설치 보고서의 sn 과 일치할 때만 제품이 있는 것으로 본다.
    const isProductMatched = !!product?.sn && product.sn === installation?.sn;

    useEffect(() => {
        let alive = true;
        if (isMatched && installation.sn) {
            setProductDone(false);
            Promise.resolve(GetProduct(installation.sn))
                .catch((e) => console.warn('[AdminInstallationInfo] GetProduct failed', { sn: installation.sn, reason: e?.message || String(e) }))
                .finally(() => { if (alive) setProductDone(true); });
        } else {
            setProductDone(true);
        }
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [installation])

    useEffect(() => {
        let alive = true;
        if (id == installation?._id) {
            setInstallDone(true);
            return undefined;
        }
        setInstallDone(false);
        setProductDone(false);
        Promise.resolve(GetInstallation(id))
            .catch((e) => console.warn('[AdminInstallationInfo] GetInstallation failed', { id, reason: e?.message || String(e) }))
            .finally(() => { if (alive) setInstallDone(true); });
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const form_controls = [
        {
            title: t('site.field.practice'), items: [
                { type: "input", name: "sitename", label: t('site.field.siteName'), val: installation.sitename, isEditable: !isSummary },
                { type: "select", name: "speciality", label: t('site.field.specialty'), val: installation.speciality, list: SpecialityTypes, isEditable: !isSummary }
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "tel", label: t('common.field.tel'), val: installation.tel, isEditable: !isSummary },
                { type: "tel", name: "fax", label: t('common.field.fax'), val: installation.fax, isEditable: !isSummary }
            ]
        },
        {
            title: "", items: [
                { type: "email", name: "email", label: t('common.field.email'), val: installation.email, isEditable: !isSummary },
                { type: "tel", name: "hp", label: t('common.field.mobile'), val: installation.hp, isEditable: !isSummary }
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "address", label: t('common.field.address'), val: installation.address, isEditable: !isSummary },
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "zipcode", label: t('common.field.zipCode'), val: installation.zipcode, isEditable: !isSummary },
                { type: "select", name: "country", label: t('common.field.country'), val: installation.country, list: CountryCode, isEditable: !isSummary }
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "website", label: t('common.field.homepage'), val: installation.website, isEditable: !isSummary }
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "customerFirstName", label: t('common.field.firstName'), val: installation.customerFirstName, isEditable: !isSummary },
                { type: "input", name: "customerLastName", label: t('common.field.lastName'), val: installation.customerLastName, isEditable: !isSummary },
                { type: "email", name: "customerEmail", label: t('common.field.email'), val: installation.customerEmail, isEditable: !isSummary },
                { type: "tel", name: "customerHp", label: t('common.field.mobile'), val: installation.customerHp, isEditable: !isSummary }
            ]
        },
        {
            title: t('product.label.productInfo'), items: [
                {
                    type: "input", name: "sn", label: t('product.field.sn'),
                    val: installation.sn, isEditable: false
                },
                { type: "input", name: "model", label: t('product.field.model'), val: installation.model, isEditable: !isSummary, required: true },
                { type: "input", name: "option", label: t('common.label.option'), val: installation.option, isEditable: !isSummary, required: true },
            ]
        },
        {
            title: "Install Information", items: [
                { type: "datetime", name: "installationDate", label: t('installation.field.installDate'), onlyDate: true, val: installation.installationDate, isEditable: !isSummary },
                { type: "input", name: "installerName", label: t('installation.field.installer'), val: installation.installerName, isEditable: !isSummary },
            ]
        },
    ]

    return (
        <>
            {isLoading && <Loading />}
            {(!isLoading && isMatched && isProductMatched) &&
                <>
                    <div className="extraHeader">
                        <h2 className="mb-0">{installation.sn}</h2>
                        <div className="ray-right">
                            <Link to="/Admin/AdminInstallationList" className="btn btn-default btn-sm mt-0 me-1">{t('common.label.list')}</Link>
                        </div>
                    </div>
                    <div id="appCapsule" className="extra-header-active full-height">
                        <RayForm controls={form_controls} />
                        <div className="section mt-1">
                            <div className="section-title">{t('installation.label.packagingCheck')}</div>
                            <div className="card">
                                <div className="card-body pb-1 pt-1">
                                    <InstallationStep2 info={installation} product={product} isSummary={isSummary} />
                                </div>
                            </div>
                        </div>
                        <div className="section mt-1">
                            <div className="section-title">{t('product.label.systemConfig')}</div>
                            <div className="card">
                                <div className="card-body pb-1 pt-1">
                                    <InstallationStep3 info={installation} product={product} isSummary={isSummary} />
                                </div>
                            </div>
                        </div>
                        <div className="section mt-1">
                            <div className="section-title">{t('product.label.imageQuality')}</div>
                            <div className="card">
                                <div className="card-body pb-1 pt-1">
                                    <InstallationStep4 info={installation} product={product} isSummary={isSummary} />
                                </div>
                            </div>
                        </div>
                        <div className="section mt-1">
                            <div className="section-title">{t('installation.label.regulatoryDocument')}</div>
                            <div className="card">
                                <div className="card-body pb-1 pt-1">
                                    <InstallationStep5 info={installation} product={product} isSummary={isSummary} />
                                </div>
                            </div>
                        </div>
                        <div className="section mt-1">
                            <div className="section-title">{t('installation.label.userTrainingCheck')}</div>
                            <div className="card">
                                <div className="card-body pb-1 pt-1">
                                    <InstallationStep6 info={installation} product={product} isSummary={isSummary} />
                                </div>
                            </div>
                        </div>
                        <div className='section mt-1'>
                            <div className='section-title'>{t('common.field.signature')}</div>
                            <div className='card'>
                                <div className='card-body pb-1 pt-1'>
                                    <RaySignaturePad sigType="Installer" reportId={installation._id} sigPath={installation} view="view"></RaySignaturePad>
                                    <RaySignaturePad sigType="Customer" reportId={installation._id} sigPath={installation} view="view"></RaySignaturePad>
                                </div>
                            </div>
                        </div>
                        {/* PDF Export — AdminSiteSurveyInfo 와 동일하게 하단 block 버튼으로 출력 */}
                        <div className="mt-2 mb-3 ms-1 me-1">
                            <ExportPdfReport reportType={'installation'} infos={installation} />
                        </div>
                    </div>
                </>
            }
            {(!isLoading && !(isMatched && isProductMatched)) &&
                <div className="section mt-2 text-center text-muted">{t('common.message.noData')}</div>
            }
        </>
    );
};

const mapState = (state) => {
    const installation = state.InstallationReducer.installation;
    const product = state.ProductReducer.product;
    const isClose = state.AlertReducer.isClose;
    return { installation, isClose, product };
}

const mapDispatch = dispatch => ({
    GetInstallation: (_id) => dispatch(InstallationAction.GetInstallation(_id)),
    GetProduct: (sn) => dispatch(ProductAction.GetProduct(sn)),
})

export default connect(mapState, mapDispatch)(AdminInstallationInfo);